<template>
    <div class="camsContainer">
        <div class="nonGraphContainer">
            <div class="pageHeader">
                <ContentHeader :name=this.headerName :subHeader="subHeader" :route="subPage" />
            </div>
        </div>
        <div class="currentView">
            <!-- These selectors should probably be their own component -->
            <div>
                <div class="dataTableSelectorGroup">
                    <div class="dataTableSelector" id="filtersModal">
                        <SearchBar v-bind:search="search"
                            v-bind:searchCallback="(data) => { this.performSearch(data) }"> </SearchBar>
                        <div class="iconGroup" @click="openGateFiletersModal">
                            <svg class="filterIcon" width="32" height="26" viewBox="0 0 32 26" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <rect width="32" height="4" fill="#699991" rx="2" />
                                <rect x="8" y="22" width="16" height="4" fill="#699991" rx="2" />
                                <rect x="4" y="11" width="24" height="4" fill="#699991" rx="2" />
                            </svg>
                        </div>
                    </div>
                </div>
                <DataTable v-bind:tableData="tableData" v-bind:search="search" :processInputData="processInputData"
                    v-bind:openModalCallback="(item) => handleModal(item)" :headers="headers" />

                <AnalyticsGraph title="At a Glance" v-bind:configuration="users" />
            </div>
        </div>
    </div>
</template>

<script>
import ContentHeader from "../../ContentHeader.vue";
import * as Constants from "../../../js/constants";
import EventBus from "../../../eventBus";
import DataTable from "../pageComps/DataTable.vue";
import SearchBar from "../pageComps/Search.vue";
import CTSRepository from "../../../js/CTSRepository";
import UnitModal from "../../modals/UnitModal.vue";

export default {
    name: "UnitsPage",
    props: ["subPage", "organizationData", "userData"],
    components: {
        ContentHeader,
        DataTable,
        SearchBar
    },
    data() {
        return {
            selectedItem: Constants.GATE,
            headerName: Constants.USERS,
            subHeader: "Below is a list of all units for your community!",
            filterStartDate: null,
            filterEndDate: null,
            defaultStartDate: null,
            defaultEndDate: null,
            filters: [],
            usersTableData: [],
            tableData: [],
            search: "",
            users: Constants.USERS,
            cardInfo: Constants.DEFAULT_CARD_INFO,
            headers: [
                { text: "Address", value: "unit_full_address", align: "start", sortable: true, width: 300 },
                { text: "Subdivision", value: "unit_subdivision", filterable: true, width: 175 },
                { text: "Associated Users", value: "unit_associated_user_string", filterable: true, width: 175 },
                { text: "Status", value: "current_status", filterable: true, width: 180 },
                { text: "Unit Type", value: "unit_type", filterable: true, width: 180 },
                { text: "Move In Date", value: "unit_move_in_date_formatted", filterable: false, width: 180 },
                { text: "Renewal Date", value: "unit_renewal_date_formatted", filterable: false, width: 180 },
                { text: "Pet?", value: "pet", filterable: false, width: 180 },
                { text: "Unit ID", value: "unit_id", filterable: false, width: 180 },
            ]
        };
    },
    watch: {
        search(newVal) {
            this.filters = this.defaultFilters
            if (newVal == "") {
                this.performSearch()
            }
        },
        organizationData: function (newVal) {
            this.communityId = newVal.organization_id
            this.performSearch()
        }
    },
    created() {
        this.changeView(this.selectedItem);
        EventBus.$on("keys", this.changeView);
        EventBus.$on("incidents", this.changeView);

        var date = new Date();
        this.defaultEndDate = date.toISOString().split('T')[0]
        var startDate = new Date(date)
        startDate.setDate(date.getDate() - 7);
        //this.defaultStartDate = startDate.toISOString().split('T')[0]
        this.defaultStartDate = "2019-06-06"


        this.performSearch("").then((apiData) => {
            console.log("Finished getting and setting API Data", apiData);
        });
    },
    methods: {
        openGateFiletersModal() {
            console.log("Opening Gate Filters Modal")
        },
        homeChangeText() {
            console.log("Home knows the button was clicked");
        },
        changeView(name) {
            console.log("Changing View from ", this.selectedItem, " to ", name);
            if (name == "keys") {
                this.showKeys = true;
                this.showIncidents = false;
                this.selectedItem = name;
            } else if (name == "incidents") {
                this.showIncidents = true;
                this.showKeys = false;
                this.selectedItem = name;
            }
        },
        performSearch(data) {
            this.search = data
            new CTSRepository(this.$props.organizationData).fetchAllUnits().then((data) => {
                console.log("Search Data", data);
                this.tableData = data
            }).catch((err) => {
                console.log("Error fetching Units", err)
            });
        },
        processInputData(inputData) {
            return inputData.map(item => {
                console.log("Mapping over item", item)
                let associatedUserString = ""
                if (item.associated_users.length > 1) {
                    associatedUserString = `${item.associated_users.length} Associated Users`
                } else if (item.associated_users.length == 1 && item.associated_users[0] != null) {
                    let associatedUser = item.associated_users[0]
                    associatedUserString = `${associatedUser.user_first_name} ${associatedUser.user_last_name}`
                }
                return {
                    ...item,
                    pet: "No",
                    unit_move_in_date_formatted: item.unit_move_in_date ? new Date(item.unit_move_in_date).toLocaleDateString() : "",
                    unit_renewal_date_formatted: item.unit_renewal_date ? new Date(item.unit_renewal_date).toLocaleDateString() : "",
                    unit_associated_user_string: associatedUserString,
                }
            })
        },
        handleModal(item) {
            this.$modal.show(UnitModal, {
                unitData: item,
                organizationData: this.$props.organizationData,
                userData: this.$props.userData,
            }, {
                transition: "fade",
                top: "0",
                width: "650",
                height: "auto",
                draggable: "true",
                adaptive: false,
                styles: "border-radius: 22px;"
            })
        },
        handleButtonPress() {
            this.$modal.show(Constants.CREATE_PET_MODAL)
        }
    },
};
</script>

<style scoped>
.dataTableSelectorGroup {
    display: flex;
    widows: 100%;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 16px;
}

.dataTableSelector:nth-child(3n) {
    margin-right: 0px;
}

.selectorContent {
    width: 100%;
    color: white;
    font-size: 28px;
    display: inline;
    margin-right: 16px;
}

.selectorContent::placeholder {
    width: 100%;
    color: white;
    font-size: 28px;
}

.pageHeader button {
    background-color: #1890FFCC;
    color: white;
}

.filterIcon {
    margin-right: 16px;
    display: inline;

}

.iconGroup {
    display: inline;
}
</style>